import { render } from "./Button-default.vue?vue&type=template&id=bf67a17e&scoped=true"
import script from "./Button-default.vue?vue&type=script&lang=js"
export * from "./Button-default.vue?vue&type=script&lang=js"

import "./Button-default.vue?vue&type=style&index=0&id=bf67a17e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf67a17e"]])

export default __exports__